import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const yesAudience = ['Tienes más de 55 años y sientes que el dolor articular está limitando tu vida', 'Estás cansada de tomar antiinflamatorios sin resolver la causa raíz', 'Quieres una solución natural, económica y basada en ciencia real', 'Estás dispuesta a pasar 20 minutos al día en tu cocina durante 7 días', 'Quieres entender tu cuerpo, no solo medicarlo'];
  const noAudience = ['Buscas una pastilla mágica que funcione sin ningún cambio de hábitos', 'No estás dispuesta a dedicar 20 minutos diarios a preparar tus alimentos', 'Tienes una condición médica severa sin supervisión médica activa', 'Esperas resultados sin seguir el protocolo completo'];
  return <section className="bg-cream py-24 px-6 md:px-12 lg:px-24" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-21">
          {/* YES Column */}
          <FadeIn data-id="element-22">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border-t-8 border-sage h-full" data-id="element-23">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-dark-green mb-8" data-id="element-24">
                Este manual ES para ti si:
              </h3>
              <div className="space-y-6" data-id="element-25">
                {yesAudience.map((item, index) => <div key={index} className="flex gap-4 items-start" data-id="element-26">
                    <CheckCircle2 className="text-sage flex-shrink-0 mt-1" size={24} data-id="element-27" />
                    <p className="text-lg text-text-black" data-id="element-28">{item}</p>
                  </div>)}
              </div>
            </div>
          </FadeIn>

          {/* NO Column */}
          <FadeIn delay={0.2} data-id="element-29">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border-t-8 border-red-400 h-full" data-id="element-30">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-text-black mb-8" data-id="element-31">
                Este manual NO es para ti si:
              </h3>
              <div className="space-y-6" data-id="element-32">
                {noAudience.map((item, index) => <div key={index} className="flex gap-4 items-start" data-id="element-33">
                    <XCircle className="text-red-400 flex-shrink-0 mt-1" size={24} data-id="element-34" />
                    <p className="text-lg text-text-gray" data-id="element-35">{item}</p>
                  </div>)}
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}